import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUserChallenges = (username, options = {}) => {
  const { enabled = true } = options;
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  
  return useQuery({
    queryKey: ['userChallenges', username],
    queryFn: async () => {
      const response = await restClient({
        url: `${prefix}/user/challenges`,
        method: 'get',
        params: { username }  
      });
      return response;
    },
    enabled: enabled && !!username,
    staleTime: 0, 
    cacheTime: 0,  
    refetchOnMount: 'always', 
    refetchOnWindowFocus: false 
  });
};
